import React, { useContext } from 'react';

import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { CSVLink } from "react-csv";
import AuthContext from  "../context/AuthContext";


export const CustomToolbar = ({
    selectedData,
    exportBtn = false,
    fileName,
    setShowCreateModal,
    expandAll,
    collapseAll,
    toolbarPermissions,
    ...rest
}) => {

    const route = window.location.href.split("/").pop();
    const date = new Date().toISOString();
    const { user } = useContext(AuthContext);


    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                {
                    toolbarPermissions?.create_permissions.includes(user?.user_type) ? 
                    <div className="my-2">
                        <Button 
                            label="New" 
                            icon="pi pi-plus" 
                            className="p-button-success mr-2" 
                            onClick={() => {
                                setShowCreateModal(true)
                            }}
                        />
                    </div> : 
                    <></>
                }
                
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            
            <React.Fragment>
                
                {
                    expandAll && (
                        <Button icon="pi pi-plus" label="Expand All" onClick={expandAll} text raised rounded outlined/>
                    )
                }
                                {
                    collapseAll && (
                        <Button icon="pi pi-minus" label="Collapse All" onClick={collapseAll} text severity="warning" raised rounded/>
                    )
                }
                {
                    toolbarPermissions?.report_permissions.includes(user?.user_type) ? 
                    exportBtn && (
                        <CSVLink asyncOnClick={true} data={selectedData} filename={`${fileName || route}-${date.split("T")[0]}`}>
                            <Button label="Export" icon="pi pi-download" className="p-button-help" />
                        </CSVLink>
                    ) : 
                    <></>
                }

            </React.Fragment>
        );
    };


    return (
        <>
            <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate}/>
        </>
    );
};